<div class="container mainbox">
    <div>
        <h1 class="form-group title-position" translate>service.service</h1>
        <form [formGroup]="addEditForm" (ngSubmit)="onSubmit()" *ngIf="service$ | async as data; else loading">
            <div class="card">
                <div class="card-body">
                    <!-- name and service type -->
                    <div class="form-group form-row">
                        <!-- name -->
                        <div class="col">
                            <label translate>service.name</label>
                            <input type="text" class="form-control" formControlName="name"
                                [ngClass]="{'is-invalid': showValidations && form.name.errors }"
                                placeholder="{{'placeholder.enter' | translate}}" />
                            <small class="text-danger" *ngIf="form.name?.errors?.required && showValidations" translate>
                                errors.required
                            </small>
                            <small class="text-danger" *ngIf="form.name?.errors?.maxlength && showValidations">
                                {{'errors.inputTooLong' | translate : {max:128} }}
                            </small>
                        </div>

                        <!-- service type -->
                        <div class="col">
                            <label translate>service.serviceType</label>
                            <select class="custom-select input-custom-size" formControlName="serviceType"
                                [compareWith]="compareById"
                                [ngClass]="{ 'is-invalid': showValidations && form.serviceType.errors }">
                                <option *ngFor="let serviceType of serviceTypes" [ngValue]="serviceType">
                                    {{serviceType.description}}
                            </select>
                            <small class="text-danger" *ngIf="form.serviceType?.errors?.required && showValidations"
                                translate>
                                errors.required
                            </small>
                        </div>

                    </div>

                    <!-- order index and valid -->
                    <div class="form-group form-row">
                        <!-- order index -->
                        <div class="col">
                            <label translate>service.orderIndex</label>
                            <input type="text" class="form-control" formControlName="orderIndex"/>
                            <small class="text-danger" *ngIf="form.orderIndex?.errors?.required && showValidations"
                             translate>
                                errors.required
                            </small>
                            <small class="text-danger" *ngIf="form.orderIndex?.errors?.pattern && showValidations"
                             translate>
                                errors.onlyDigits
                            </small>
                            <small class="text-danger"
                            *ngIf="form.orderIndex?.errors?.maxlength && showValidations">
                            {{'errors.inputTooLong' | translate : {max:8} }}
                        </small>
                        </div>

                        <!-- valid -->
                        <div class="col">
                            <label translate>service.isValid</label>
                            <select class="custom-select input-custom-size" formControlName="isValid">
                                <option *ngFor="let option of options" [value]="option.code">
                                    {{option.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- rvs categories -->
                    <div class="form-group form-row">
                        <!-- rvs categories -->
                        <div class="col">
                            <mat-form-field class="mat-form-field-small">
                                <mat-label translate>service.rvsCategories</mat-label>
                                <mat-select multiple formControlName="selectedRvsCategories"
                                    [compareWith]="compareById">
                                    <mat-option (onSelectionChange)="change($event)"
                                        *ngFor="let rvsCategory of rvsCategories" [value]="rvsCategory">
                                        {{rvsCategory.code}}
                                    </mat-option>
                                </mat-select>
                                <small class="text-danger"
                                        *ngIf="form.selectedRvsCategories?.errors?.required && showValidations"
                                        translate>
                                        errors.required
                                    </small>
                            </mat-form-field>
                        </div>
                    </div>
                    
                    <!-- description -->
                    <div class="form-group form-row">
                        <!-- description -->
                        <div class="col">
                            <label translate>service.description</label>
                            <input type="text" class="form-control" formControlName="description"
                                [ngClass]="{'is-invalid': showValidations && form.description.errors }"
                                placeholder="{{'placeholder.enter' | translate}}" />
                            <small class="text-danger" *ngIf="form.description?.errors?.maxlength && showValidations">
                                {{'errors.inputTooLong' | translate : {max:512} }}
                            </small>
                        </div>
                    </div>

                    <!-- service-type-dependent fields (main 'M' / additional 'A') -->
                    <ng-container *ngIf="showExtraFields">
                        <!-- duration and minimal price -->
                        <div class="form-group form-row">
                            <!-- duration in minutes -->
                            <div class="col">
                                <label translate>service.durationMinutes</label>
                                <input type="number" class="form-control" formControlName="durationMinutes"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{'is-invalid': showValidations && form.durationMinutes.errors }" />
                                <small class="text-danger"
                                    *ngIf="form.durationMinutes?.errors?.pattern && showValidations" translate>
                                    errors.onlyDigits
                                </small>
                                <small class="text-danger"
                                    *ngIf="form.durationMinutes?.errors?.maxlength && showValidations">
                                    {{'errors.inputTooLong' | translate : {max:8} }}
                                </small>
                            </div>

                            <!-- minimal price in euro -->
                            <div class="col">
                                <label translate>service.minimalPriceEuro</label>
                                <input type="text" class="form-control" formControlName="minimalPriceEuro"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{'is-invalid': showValidations && form.minimalPriceEuro.errors }" />
                                <small class="text-danger"
                                    *ngIf="form.minimalPriceEuro?.errors?.pattern && showValidations" translate>
                                    errors.onlyPositiveNumbers
                                </small>
                                <small class="text-danger"
                                    *ngIf="form.minimalPriceEuro?.errors?.maxlength && showValidations">
                                    {{'errors.inputTooLong' | translate : {max:11} }}
                                </small>
                            </div>
                        </div>

                        <!-- more information -->
                        <div class="form-group form-row">
                            <div class="col">
                                <label translate>service.moreInformation</label>
                                <textarea rows="4" maxlength="1024" class="form-control" formControlName="moreInformation"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{'is-invalid': showValidations && form.moreInformation.errors }"></textarea>
                                <small class="text-danger"
                                    *ngIf="form.moreInformation?.errors?.maxlength && showValidations">
                                    {{'errors.inputTooLong' | translate : {max:1024} }}
                                </small>
                            </div>
                        </div>

                        <!-- needed documents (main service only) -->
                        <div class="form-group form-row" *ngIf="isMainService">
                            <div class="col">
                                <label translate>service.neededDocuments</label>
                                <textarea rows="4" maxlength="1024" class="form-control" formControlName="neededDocuments"
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{'is-invalid': showValidations && form.neededDocuments.errors }"></textarea>
                                <small class="text-danger"
                                    *ngIf="form.neededDocuments?.errors?.maxlength && showValidations">
                                    {{'errors.inputTooLong' | translate : {max:1024} }}
                                </small>
                            </div>
                        </div>
                    </ng-container>

                    <!-- picture -->
                    <div class="form-group form-row">
                        <div class="col">
                            <label translate>service.picture</label>
                            <input #pictureInput type="file"
                                accept="image/png, image/jpeg, image/gif" class="file-input"
                                (change)="onFileSelected($event)" />
                            <span class="invalid-format" *ngIf="invalidFileType" translate>Невалиден файл формат</span>
                            <span class="invalid-format" *ngIf="invalidFileSize" translate>service.pictureTooLarge</span>

                            <!-- image preview (newly selected file or stored base64 on edit) -->
                            <div *ngIf="imageUrl" class="mt-2">
                                <img height="200" [src]="imageUrl" alt="Selected Image" />
                                <div class="mt-2">
                                    <button type="button" class="btn btn-outline-danger btn-sm"
                                        (click)="removePicture(pictureInput)" translate>button.remove</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="text-right">
                <button class="btn btn-primary w-20" type="submit"  *ngIf="perms.hasAccess(perms.CAN_ADD_EDIT_SERVICE)" translate>button.save</button>
            </div>
        </form>

        <ng-template #loading>
            <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
                <div class="alert alert-danger">
                    {{errorMessage}}
                </div>
                <div class="d-flex justify-content-center">
                    <i class="fa fa-refresh" (click)="reload()"></i>
                </div>
            </div>
            <ng-template #spinner>
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </ng-template>
        </ng-template>
    </div>
</div>